import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Avatar,
} from '@mui/material';
import {
  Email as EmailIcon,
  Edit as TemplateIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon,
  Dashboard as DashboardIcon,
  Campaign as CampaignIcon,
  People as ContactsIcon,
  // VerifiedUser as ValidatorIcon,
} from '@mui/icons-material';

interface SidebarProps {
  currentView: string;
  onViewChange: (view: string) => void;
}

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
  { id: 'compose', label: 'Compose Email', icon: <EmailIcon /> },
  { id: 'campaigns', label: 'Campaigns', icon: <CampaignIcon /> },
  { id: 'contacts', label: 'Contacts', icon: <ContactsIcon /> },
  { id: 'templates', label: 'Templates', icon: <TemplateIcon /> },
  // { id: 'email-validator', label: 'Email Validator', icon: <ValidatorIcon /> },
  { id: 'analytics', label: 'Analytics', icon: <AnalyticsIcon /> },
  { id: 'settings', label: 'Settings', icon: <SettingsIcon /> },
];

const Sidebar: React.FC<SidebarProps> = ({ currentView, onViewChange }) => {
  return (
    <Box
      className="sidebar"
      sx={{
        width: 280,
        height: '100vh',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Avatar
          sx={{
            width: 60,
            height: 60,
            mx: 'auto',
            mb: 2,
            bgcolor: 'rgba(255, 255, 255, 0.2)',
            fontSize: '1.5rem',
          }}
        >
          📧
        </Avatar>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
          Email Outreach
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Professional Platform
        </Typography>
      </Box>

      <Divider sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)', mb: 2 }} />

      {/* Navigation Menu */}
      <List sx={{ px: 0, flexGrow: 1, overflow: 'auto' }}>
        {menuItems.map((item) => (
          <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              className={`sidebar-item ${currentView === item.id ? 'active' : ''}`}
              onClick={() => onViewChange(item.id)}
              sx={{
                borderRadius: 2,
                py: 1.5,
                px: 2,
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                },
                ...(currentView === item.id && {
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                  '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.25)',
                  },
                }),
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 40 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontWeight: currentView === item.id ? 600 : 400,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* Footer */}
      <Box sx={{ pt: 4, flexShrink: 0 }}>
        <Divider sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)', mb: 2 }} />
        <Typography variant="caption" sx={{ opacity: 0.6, textAlign: 'center', display: 'block' }}>
          Version 1.0.0
        </Typography>
      </Box>
    </Box>
  );
};

export default Sidebar;
